type SessionAccess = {
  role: string;
  pages: Record<string, true>;
  actions: Record<string, true>;
};

let session: SessionAccess | null = null;

/** ADMINISTRATOR is the same access identity as ADMIN. */
export function normalizeAccessRole(role: unknown): string {
  const raw = String(role ?? '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '_');
  if (raw === 'ADMINISTRATOR') return 'ADMIN';
  return raw;
}

export function setSessionAccess(role: unknown, pages: string[], actions: string[]): void {
  const code = normalizeAccessRole(role);
  const pageMap: Record<string, true> = {};
  const actionMap: Record<string, true> = {};
  for (let i = 0; i < pages.length; i++) pageMap[pages[i]] = true;
  for (let i = 0; i < actions.length; i++) actionMap[actions[i]] = true;
  session = { role: code, pages: pageMap, actions: actionMap };
}

export function clearSessionAccess(): void {
  session = null;
}

export function sessionAllowsPage(role: unknown, page: string): boolean | null {
  if (!session) return null;
  const code = normalizeAccessRole(role);
  if (!code || code !== session.role) return null;
  return !!session.pages[page];
}

export function sessionAllowsAction(role: unknown, action: string): boolean | null {
  if (!session) return null;
  const code = normalizeAccessRole(role);
  if (!code || code !== session.role) return null;
  return !!session.actions[action];
}
